module.exports = __webpack_public_path__ + "static/media/How to add a team member.e1a8689b.png";